import { IMAGE_REPLACEMENT_PACK } from '@kitup/book-schema';
import { formatPrice } from '@kitup/brand';
import { useState, type JSX } from 'react';
import { useBrand } from '../brand/context.js';
import { useI18n } from '../i18n/context.js';
import { PaymentTerms } from './PaymentTerms.js';

export function ReplacementPackModal({
  pending,
  error,
  onClose,
  onPay,
}: {
  readonly pending: boolean;
  readonly error: boolean;
  onClose(): void;
  onPay(): void;
}): JSX.Element {
  const { t, locale } = useI18n();
  const brand = useBrand();
  const price = formatPrice(brand.imagePackPrice, brand, locale);
  const [termsAccepted, setTermsAccepted] = useState(false);

  return (
    <div
      className="fixed inset-0 z-50 grid place-items-center bg-slate-950/45 p-4"
      role="presentation"
    >
      <section
        role="dialog"
        aria-modal="true"
        aria-labelledby="replacement-pack-title"
        className="kitup-card w-full max-w-lg p-6 shadow-2xl"
      >
        <div className="flex items-start justify-between gap-4">
          <h2 id="replacement-pack-title" className="text-2xl font-semibold">
            {t.monetization.replacementPack.title}
          </h2>
          <button type="button" className="kitup-quiet-button" disabled={pending} onClick={onClose}>
            {t.common.close}
          </button>
        </div>
        <p className="mt-4 text-sm text-[var(--kitup-color-muted)]">
          {t.monetization.replacementPack.text(IMAGE_REPLACEMENT_PACK.count)}
        </p>
        <div className="mt-4">
          <PaymentTerms checked={termsAccepted} disabled={pending} onChange={setTermsAccepted} />
        </div>
        <button
          type="button"
          className="kitup-primary-button mt-4 w-full justify-center"
          disabled={pending || !termsAccepted}
          onClick={onPay}
        >
          {pending
            ? t.monetization.replacementPack.processing
            : t.monetization.replacementPack.action(price)}
        </button>
        {error ? (
          <p role="alert" className="mt-3 text-sm text-red-700">
            {t.monetization.replacementPack.error}
          </p>
        ) : null}
      </section>
    </div>
  );
}
